import { objectTypes, messageTypes } from "./constants";

export const getObjectTypeOptions = (resources) => {
	return objectTypes(resources).map((type) => ({
		key: type.key,
		name: type.name,
	}));
};

export const getMessageTypeOptions = (resources) => {
	return messageTypes.map((type) => ({
		key: type.key,
		name: resources[type.resourceKey],
	}));
};

export const getBrandOptions = (brands, resources) => {
	const defaultBrand = {
		key: 0,
		name: resources["All"],
	};

	const options = brands.map((brand) => ({
		key: brand.id,
		name: brand.description,
	}));

	return [defaultBrand, ...options];
};

export const getUseCaseOptions = (useCases) => {
	return useCases.map((useCase) => ({
		key: useCase.id,
		name: useCase.description,
	}));
};

export const formatOutlets = (outlets) => {
	if (!outlets || !outlets.length) return [];

	const sortedOutlets = [...outlets].sort((a, b) =>
		a.description.localeCompare(b.description)
	);

	return sortedOutlets.map((outlet) => ({
		key: outlet.id,
		name: outlet.description,
	}));
};
